import { useOutletContext } from 'react-router-dom'
import { Rubrica } from 'service/api'

export function useRubricasOutletContext() {
    return useOutletContext<{ data: Rubrica[] }>()
}
